import React, { useEffect, useRef, useState } from 'react';
import samhLogo from '../assets/images/samh-logo.jpg';
import casLogo from '../assets/images/children-aid-society-logo.png';

export default function Beneficiaries() {
  const casRef = useRef(null);
  const samhRef = useRef(null);
  const [casVisible, setCasVisible] = useState(false);
  const [samhVisible, setSamhVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (casRef.current) {
        const rect = casRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8) {
          setCasVisible(true);
        }
      }
      
      if (samhRef.current) {
        const rect = samhRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8) {
          setSamhVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="text-center animate-fade-in pb-32 sm:pb-48 md:pb-64" style={{ backgroundColor: '#faf8f5' }}>
      {/* Title */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8 pb-3 sm:pb-4">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
          Who we stand for
        </h1>
      </div>

      {/* Content Wrapper – adds margin like About Us */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-8 sm:mt-12 md:mt-16">
        {/* Children's Aid Society Section */}
        <div
          ref={casRef}
          className={`grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 md:gap-16 items-center max-w-7xl mx-auto mb-16 sm:mb-24 md:mb-32 transition-all duration-1000 ${
            casVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'
          }`}
        >
          {/* Logo Section */}
          <div className="flex justify-center md:justify-start">
            <div className="bg-white p-6 sm:p-8 md:p-12 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 w-full max-w-sm md:max-w-md flex items-center justify-center" style={{ minHeight: '160px' }}>
              <img 
                src={casLogo} 
                alt="Children's Aid Society Logo" 
                className="w-full h-auto max-w-full object-contain"
                style={{ maxHeight: '180px', objectFit: 'contain', objectPosition: 'center' }}
              />
            </div>
          </div>
          
          {/* Description Section */}
          <div className="space-y-4 sm:space-y-6 md:space-y-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-red-600">Children's Aid Society</h2>
            
            <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
              Established in 1902, Children's Aid Society (CAS) is one of Singapore's oldest secular philanthropic organisations. Through Melrose Home and Melrose Care, CAS provides residential care and specialised therapies to support children and youths who have experienced abuse or neglect. CAS seeks to mitigate the impact of these circumstances so that the children and youths have better outcomes in terms of mental health, educational outcomes, and peer relationships.
            </p>

            <p className="text-sm sm:text-base md:text-lg">
              <a
                href="https://www.childrensaidsociety.org.sg"
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-600 hover:text-red-800 underline transition-colors duration-200"
              >
                Find out more about Children's Aid Society.
              </a>
            </p>
          </div>
        </div>
        
        {/* Singapore Association for Mental Health Section */}
        <div 
          ref={samhRef}
          className={`grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 md:gap-16 items-center max-w-7xl mx-auto transition-all duration-1000 ${
            samhVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'
          }`}
        >
          {/* Logo Section */}
          <div className="flex justify-center md:justify-start">
            <div className="bg-white p-6 sm:p-8 md:p-12 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 w-full max-w-sm md:max-w-md flex items-center justify-center">
              <img 
                src={samhLogo} 
                alt="SAMH Logo" 
                className="w-full h-auto max-w-full object-contain"
              />
            </div>
          </div>
          
          {/* Description Section */}
          <div className="space-y-4 sm:space-y-6 md:space-y-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-red-600 text-center">
              Singapore Association for <span className="whitespace-nowrap">Mental Health</span>
            </h2>
            
            <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
              Established in 1968, the Singapore Association for Mental Health (SAMH) is Singapore's first mental health social service agency, supporting youths, adults, and seniors. SAMH offers a comprehensive range of rehabilitative, outreach, and creative services designed to assist individuals with mental health issues and promote mental wellness for all. Through various initiatives, SAMH enhances mental resilience, provides crucial support for reintegration, and focuses on preventive care. Committed to improving lives and nurturing minds, SAMH strives to build a more supportive and inclusive community.
            </p>

            <p className="text-sm sm:text-base md:text-lg">
              <a
                href="https://www.samhealth.org.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-600 hover:text-red-800 underline transition-colors duration-200"
              >
                Find out more about Singapore Association for Mental Health.
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}